"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _useFreezeBody2 = _interopRequireDefault(require("./useFreezeBody"));
var DEFAULT_THRESHOLD = 10;
var useSwipe = function useSwipe(options) {
  var ref = options.ref,
    _options$swipeThreshh = options.swipeThreshhold,
    swipeThreshhold = _options$swipeThreshh === void 0 ? DEFAULT_THRESHOLD : _options$swipeThreshh,
    onSwipeUp = options.onSwipeUp,
    onSwipeDown = options.onSwipeDown,
    onSwipeRight = options.onSwipeRight,
    onSwipeLeft = options.onSwipeLeft;
  var touchStartY = null;
  var touchStartX = null;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    deltaY = _useState2[0],
    setDeltaY = _useState2[1];
  var _useFreezeBody = (0, _useFreezeBody2["default"])(),
    setIsFreeze = _useFreezeBody.setIsFreeze;
  (0, _react.useEffect)(function () {
    var handleTouchStart = function handleTouchStart(event) {
      touchStartY = event.touches[0].clientY;
      touchStartX = event.touches[0].clientX;
      setIsFreeze(true);
    };
    var handleTouchEnd = function handleTouchEnd(event) {
      if (touchStartY !== null) {
        var touchEndY = event.changedTouches[0].clientY;
        var finalDeltaY = touchEndY - touchStartY;
        if (finalDeltaY > swipeThreshhold && touchEndY > touchStartY && onSwipeDown) {
          onSwipeDown();
          setIsFreeze(false);
        }
        if (finalDeltaY > swipeThreshhold && touchEndY < touchStartY && onSwipeUp) {
          onSwipeUp();
          setIsFreeze(false);
        }
        touchStartY = null;
      }
      if (touchStartX !== null) {
        var touchEndX = event.changedTouches[0].clientX;
        var deltaX = touchEndX - touchStartX;
        if (deltaX > swipeThreshhold && touchEndX > touchStartX && onSwipeRight) {
          onSwipeRight();
          setIsFreeze(false);
        }
        if (deltaX > swipeThreshhold && touchEndX < touchStartX && onSwipeLeft) {
          onSwipeLeft();
          setIsFreeze(false);
        }
        touchStartX = null;
      }
    };
    var handleTouchMove = function handleTouchMove(e) {
      if (touchStartY !== null && e.touches[0].clientY > touchStartY) setDeltaY(e.touches[0].clientY - touchStartY);
    };
    var element = ref.current;
    if (element) {
      element.addEventListener('touchstart', handleTouchStart);
      element.addEventListener('touchend', handleTouchEnd);
      element.addEventListener('touchmove', handleTouchMove);
    }
    return function () {
      if (element) {
        element.removeEventListener('touchstart', handleTouchStart);
        element.removeEventListener('touchend', handleTouchEnd);
        element.removeEventListener('touchmove', handleTouchMove);
      }
    };
  }, [ref, onSwipeUp, onSwipeDown, onSwipeRight, onSwipeLeft]);
  var resetSwiper = function resetSwiper() {
    setDeltaY(0);
  };
  return {
    deltaY: deltaY,
    resetSwiper: resetSwiper
  };
};
var _default = exports["default"] = useSwipe;